// extracted by mini-css-extract-plugin
export default {"base":"base-rHm4d","baseNoScroll":"baseNoScroll-xvvNf","wrapper":"wrapper-dyZQP","slide":"slide-Ew8Qm","itemWrapper":"itemWrapper-UMjOe","item":"item-zU8TV"};